'use strict';

//var $ = require('jQuery');
import mixitup from 'mixitup';
//import MatchHeight from 'vanilla-js-match-height';

/**
 * Add the JS needed for filtering the posts by category in the Latest Posts block
 */
function latest_posts_filter() {
    let $posts = $( '.latest-posts-posts' );

    if ( ! $posts.length) {
        return;
    }

    let max_post_count = $( '.latest-posts' ).attr( 'data-filter-count' );

    mixitup('.latest-posts-posts', {
        selectors: {
            target: '.post'
        },
        callbacks: {
            onMixEnd: function( state, mixObject ){
                var filter_term = state.activeFilter.selector.replace( /\./g, '' );

                var $filtered_mix =  $( `#${ state.id } .post` );
                var visible_count = 0;

                $.each( $filtered_mix, ( index, post ) => {
                    var $post = $( post );

                    // hide any post that are greater than the maximum allowed post
                    if ( state.totalShow >= max_post_count ) {
                        if ( $post.is( ':visible' ) ) {
                            visible_count++;
                        }

                        if ( state.totalShow > max_post_count && visible_count > max_post_count && $post.is( ':visible' ) ) {
                            $post.hide();
                        } else {
                            // fix a bug when switching between showing all the posts and then changing to a category view
                            // go through all of the posts that are supposed to visible and then make them visible since they are hidden for some reason
                            $.each( state.show, ( index2, post2 ) => {
                                var $post2 = $( post2 );

                                if ( $post2.attr( 'class' ) == $post.attr( 'class' ) ) {
                                    $post.show();
                                }
                            } );
                        }
                    }

                    if ( 'all' !== filter_term && $post.is( ':visible' ) ) {
                        var $term = $post.find( '.post-terms' );
                        var categories = $post.attr( 'data-categories' );

                        if ( categories ) {
                            categories = JSON.parse( categories );
                            if ( categories.hasOwnProperty( filter_term ) ) {
                                $term.html( categories[filter_term] );
                            }
                        }
                    }
                } );
            }
        }
    } );

    // trigger a click event on page load to set the filter
    $( '.latest-posts-terms .post-filter.checked' ).click();

    // bind filter button click
    $( '.latest-posts-terms .post-filter' ).on( 'click touch', function ( event ) {
        var $this = $( event.target );
        $( '.latest-posts-terms button' ).removeClass( 'checked' );
        $this.addClass( 'checked' );
    } );
}

/**
 * On single posts, move category label(s) from below the post title to above it.
 */
function post_category_header() {
    var $categories = $( 'body.single .hero-section .meta-categories' );

    if ( ! $categories.length ) {
        return;
    }

    $categories.prependTo( $( '.entry-header' ) );
}

/**
 * Mono Lake Webcams script for the webcams page
 */
function webcams() {
    if ( window.hasOwnProperty( 'WowzaPlayer' ) && typeof window.WowzaPlayer !== 'undefined' && window.WowzaPlayer && document.querySelector( '#playerElement' ) ) {
        WowzaPlayer.create("playerElement",
            {
                "license": "PLAY1-4b9cE-pnyVn-Px7w7-NrQ7P-jUCuk",
                "sources": [{
                    "sourceURL": "https://video.parks.ca.gov/Mono/MonoLake.stream/playlist.m3u8"
                },
                    {
                        "sourceURL": ""
                    }],
                "title": "Mono Lake Tufa SNR Live Stream",
                "description": "Mono Lake Tufa SNR Live Stream",
                "autoPlay": true,
                "mute": false,
                "volume": 75,
                "sourceURL": "https://*.parks.ca.gov/Mono/MonoLake.stream/playlist.m3u8"
            }
        );
    }
}

/**
 * Add functionality to filter posts and custom post types by their published year.
 *
 * This is useful for the resource post types where they can be filtered by the resource year
 */
function post_filter_by_year() {
    if ( ! $( 'form.post-filter select[name*="publish-year"]' ).length ) {
        return;
    }

    $( 'form.post-filter select[name*="publish-year"]' ).on( 'change', ( event ) => {
        var $this = $( event.target );

        if ( $this.val().trim() ) {
            // redirect to the page that filters the posts by year
            window.location = $this.val();
            // prevent the form submission below while we wait for the page location to change
            throw true;
        }
    } );
}

/**
 * Change the homepage url if the user is on a WooCommerce shop page
 */
function shop_home_url( localized_data ) {
    if ( localized_data && localized_data.hasOwnProperty( 'shop_url' ) && localized_data.shop_url.length > 0 ) {
        $.each( $( 'a[href]' ), ( index, link ) => {
            var $link = $( link );

            if ( $link.prop( 'href' ) === localized_data.home_url ) {
                $link.prop( 'href', localized_data.shop_url );
            }
        } );
    }
}

/**
 * Keep the footer utility menu's top offset in sync with where the intro
 * paragraph under the "Mono Lake Committee" heading actually starts, since
 * the heading can wrap to a different number of lines depending on
 * viewport width. Measured from the paragraph itself (not just the
 * heading's height) because the paragraph carries its own top margin
 * (WordPress's block spacing) on top of the heading's height. Exposed as
 * --ml-footer-heading-height and used by the nav's margin-top (see
 * _footer.scss) instead of a hardcoded padding value.
 */
function footer_utility_menu_align() {
    var column = document.querySelector( '.ct-footer [data-row="top"] [data-column="widget-area-1"]' );
    var heading = column && column.querySelector( '.ct-widget:first-child .widget-title' );
    var paragraph = column && column.querySelector( '.ct-widget:first-child .textwidget' );

    if ( ! column || ! heading || ! paragraph ) {
        return;
    }

    var setOffset = function() {
        var offset = paragraph.getBoundingClientRect().top - column.getBoundingClientRect().top;
        document.documentElement.style.setProperty( '--ml-footer-heading-height', offset + 'px' );
    };

    setOffset();

    // Web font swaps (e.g. Lora/Noto Sans finishing their async load) can
    // shift the paragraph's position without changing the heading's own
    // box size, which a ResizeObserver on the heading alone wouldn't catch.
    if ( document.fonts && document.fonts.ready ) {
        document.fonts.ready.then( setOffset );
    }

    // Belt-and-suspenders: something on this page (a plugin doing a late
    // AJAX-driven reflow, a delayed style change, etc.) can shift the
    // paragraph's MARGIN without changing its own box size — which none of
    // the above catches, since ResizeObserver only fires on size changes,
    // not position/margin changes. Re-check a few times over the next few
    // seconds after load to catch anything else that moves it late.
    //
    // This script loads async, so `load` may have already fired by the
    // time this runs — an addEventListener( 'load', ... ) in that case
    // would never call back, since the event already happened in the past.
    // Check readyState first and run immediately if we're already past it.
    var startPolling = function() {
        var checks = 0;
        var interval = setInterval( function() {
            setOffset();
            checks++;
            if ( checks >= 10 ) {
                clearInterval( interval );
            }
        }, 300 );
    };

    if ( document.readyState === 'complete' ) {
        startPolling();
    } else {
        window.addEventListener( 'load', startPolling );
    }

    if ( window.ResizeObserver ) {
        var observer = new ResizeObserver( setOffset );
        observer.observe( heading );
        observer.observe( paragraph );
    } else {
        window.addEventListener( 'resize', setOffset );
    }
}

if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', footer_utility_menu_align );
} else {
    footer_utility_menu_align();
}

( function( $, loaclized_data ) {
    $( document ).ready( ( $ ) => {
        latest_posts_filter();
        post_category_header();
        webcams();
        post_filter_by_year();
        shop_home_url( loaclized_data );
    } );
} )( window.jQuery, window.crate );


//
// /* example of requiring a JS package and implementing it */
// var imagesLoaded = require('imagesloaded');
// imagesLoaded( 'body', { background: true }, function() {
//   console.log('site images loaded');
// });
